export const shouldRevalidate = () => false

export default function MapIndexRoute() {
  return null
}
